import React, { useState } from 'react';

import { Card, MarkdownRenderer, ScrollableContainer, AccordionRow } from '@ergeon/core-components';

import { CustomerDetail } from '../../../types';
import { NoExecutiveSummaryEmptyState } from '../../EmptyStates';
import { getAccordionExpanded, setAccordionExpanded } from '../../../utils/appStorage';

type ExecutiveSummaryProps = {
  customerDetail: CustomerDetail | null;
};

const ACCORDION_KEY = 'executiveSummary';

const ExecutiveSummary: React.FC<ExecutiveSummaryProps> = ({ customerDetail }) => {
  const [expanded, setExpanded] = useState(() => getAccordionExpanded(ACCORDION_KEY, true));

  const handleExpandChange = (isExpanded: boolean) => {
    setExpanded(isExpanded);
    setAccordionExpanded(ACCORDION_KEY, isExpanded);
  };

  if (!customerDetail) return null;

  return (
    <Card className="flex flex-col gap-3 px-4 py-0 w-full" flavor="base" zIndex="1">
      <AccordionRow
        expanded={expanded}
        hasBorder={false}
        isFullWidth
        setExpanded={handleExpandChange}
        title="Executive Summary">
        <Card className="flex flex-col flex-1 px-4 min-h-0 overflow-hidden" flavor="regular">
          {customerDetail.executive_summary ? (
            <ScrollableContainer direction="col">
              <MarkdownRenderer content={customerDetail.executive_summary} />
            </ScrollableContainer>
          ) : (
            <NoExecutiveSummaryEmptyState />
          )}
        </Card>
      </AccordionRow>
    </Card>
  );
};

export default ExecutiveSummary;
